import * as types from './showPageActionTypes';

export const getShowPages = () => ({
    type: types.GET_SHOW_PAGE_REQUEST
});



// WEBPACK FOOTER //
// ./src/store/showPage/showPageActions.js